import type { ReactElement } from "react";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { FiltersChip } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import type FindKeywordsFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/KeywordsFilter/KeywordsFilter";

const KeywordsFilterResult = ({
    value,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindKeywordsFilter>): ReactElement | null => {
    if (!value?.keyword) {
        return null;
    }

    return (
        <FilterResultContainer>
            <FiltersChip
                id={value.keyword}
                text={value.keyword}
                hideActionButton={!isActionEnabled}
                chipStatus={onGetLifecycleStatus?.(value)}
                onClose={() => {
                    onFilterValueRemove?.();
                    onFilterUpdate();
                }}
            />
        </FilterResultContainer>
    );
};

export default KeywordsFilterResult;
